document.addEventListener("DOMContentLoaded", function () {
    const selectedAll = document.querySelectorAll(".wrapper-dropdown");
  
    selectedAll.forEach((selected) => {
      const optionsList = selected.querySelectorAll("div.wrapper-dropdown li");
      const selectedDisplay = selected.querySelector(".selected-display");
  
      selected.addEventListener("click", () => {
        let arrow = selected.children[1];
  
        if (selected.classList.contains("active")) {
          handleDropdown(selected, arrow, false);
        } else {
          let currentActive = document.querySelector(".wrapper-dropdown.active");
  
          if (currentActive) {
            let anotherArrow = currentActive.children[1];
            handleDropdown(currentActive, anotherArrow, false);
          }
  
          handleDropdown(selected, arrow, true);
        }
      });
  
      // Actualizar el display del dropdown al seleccionar un estado
      optionsList.forEach((o) => {
        o.addEventListener("click", () => {
          const id = o.id;
          if (!id) return;
  
          selectedDisplay.innerHTML = o.innerHTML;
  
          // Mostrar el estado correspondiente en la información y actualizar paths
          handleStateSelection(id);
        });
      });
    });
  
    // Cerrar dropdowns si se hace clic fuera de ellos
    window.addEventListener("click", function (e) {
      if (e.target.closest(".wrapper-dropdown") === null) {
        closeAllDropdowns();
      }
    });
  
    // Cerrar todos los dropdowns
    function closeAllDropdowns() {
      const selectedAll = document.querySelectorAll(".wrapper-dropdown");
      selectedAll.forEach((selected) => {
        let arrow = selected.children[1];
        handleDropdown(selected, arrow, false);
      });
    }
  
    // Abrir o cerrar un dropdown específico
    function handleDropdown(dropdown, arrow, open) {
      if (open) {
        arrow.classList.add("rotated");
        dropdown.classList.add("active");
      } else {
        arrow.classList.remove("rotated");
        dropdown.classList.remove("active");
      }
    }
  
    // Obtener los elementos necesarios
    const countries = document.querySelectorAll("#dropdown .item");
    const paths = document.querySelectorAll(".content-map-blog svg path");
  
    // Marcar los paths que coincidan con los estados
    countries.forEach((country) => {
      const countryId = country.id;
  
      paths.forEach((path) => {
        if (path.id === countryId) {
          path.classList.add("active"); // Marcar los paths correspondientes con 'active'
        }
      });
    });
  
    // Manejar clics en los paths con la clase 'active'
    paths.forEach((path) => {
      path.addEventListener("click", function () {
        if (!path.classList.contains("active")) return;
  
        const id = path.id;
  
        // Mostrar el estado correspondiente en la información y actualizar dropdown
        handleStateSelection(id);
      });
    });
  
    // Función para manejar la selección de un estado
    function handleStateSelection(stateId) {
      // Actualizar el texto del "selected-display" del dropdown
      const selectedOption = document.querySelector(`#dropdown .item#${stateId}`);
      const selectedDisplay = document.querySelector(".selected-display");
      if (selectedOption) {
        selectedDisplay.innerHTML = selectedOption.innerHTML;
      }
  
      // Remover la clase 'show' de todos los paths
      paths.forEach((path) => {
        path.classList.remove("show");
      });
  
      // Agregar la clase 'show' al path correspondiente
      const activePath = document.querySelector(`.content-map-blog svg path#${stateId}`);
      if (activePath) {
        activePath.classList.add("show");
      }
  
      // Remover la clase 'active' de cualquier elemento visible previamente
      const activeStateInfo = document.querySelector(".state-info.active");
      if (activeStateInfo) {
        activeStateInfo.classList.remove("active");
      }
  
      // Buscar el nuevo elemento que debe ser visible y agregar la clase 'active'
      const stateInfo = document.querySelector(`.state-info.state--${stateId}`);
      if (stateInfo) {
        stateInfo.classList.add("active");
      }
    }
  });
  